import { useNavigate } from 'react-router';
import { createDataEntryRouteWithStep, createPathForRoute } from '../constants/baseRoutePaths';
import { checkNA } from '../utils/checkNA';
import type { FieldProps } from '../types';

type FieldHandler = (value: string | FieldProps[], decodeValue?: string) => string | null;

const checkboxHandler: FieldHandler = (value) => {
  if (!Array.isArray(value)) return checkNA(value);
  return value
    .map(({ fieldName }: FieldProps, i: number) => `${fieldName}${i !== value.length - 1 ? ', ' : ''}`)
    .join('');
};

const radioHandler: FieldHandler = (value, decodeValue) => {
  return decodeValue || checkNA(value);
};

const defaultHandler: FieldHandler = (value) => {
  return checkNA(value);
};

const handlers: Record<string, FieldHandler> = {
  checkbox: checkboxHandler,
  radio: radioHandler,
};

function printValueOrNA(value: string | FieldProps[], decodeValue: string, type: string) {
  const handler = handlers[type] || defaultHandler;
  return handler(value, decodeValue);
}

const RecapStep = ({ steps, step, hided }: { steps: any[]; step: number; hided: boolean }) => {
  const navigate = useNavigate();

  return (
    <div className="p-0 w-full xl:w-6/12 xl:odd:pr-2 xl:even:pl-2">
      <fieldset className="my-0.5 h-full rounded-md border-2 border-solid border-black-600 p-2">
        <legend className="font-bold">
          Step {step} (
          <a
            href={createPathForRoute(createDataEntryRouteWithStep(step))}
            onClick={(e) => {
              e.preventDefault();
              navigate(createPathForRoute(createDataEntryRouteWithStep(step)));
            }}
          >
            torna a questo step
          </a>
          )
        </legend>
        {steps.map(({ name, value, unit, decodeValue, type }) => (
          <div className={`py-1 ${checkNA(value) === 'N/A' && hided ? 'hidden' : ''}`} key={name}>
            <span className="font-semibold">{name}: </span>
            {checkNA(value) === 'N/A' ? '⚠️ ' : '✅ '}
            {printValueOrNA(value, decodeValue, type)}
            {unit ? ` (${unit})` : ''}
          </div>
        ))}
      </fieldset>
    </div>
  );
};

export default RecapStep;
